import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import PageHeader from "../../../components/Common/PageHeader";
import TableFilterDynamique from "components/Common/TableFilter/TableFilterDynamique";
import { FilterField } from "../../../components/Common/TableFilter/TableFilter";

import useUsers from "../hooks/useUsers";
import UsersTable from "../tables/UsersTable";

import { User } from "types/superAdmin/userTypes";
import { all_routes } from "router/all_routes";
import { ROLE_OPTIONS } from "constants/userConstants";



const UsersPage = () => {
  const { t } = useTranslation();

  const {
    users,
    loading,
    handleGetUsers,
    handleUpdate,
    infoPagination,
  } = useUsers();

  const breadcrumbItems = [
    { label: "dashboard", path: all_routes.superAdmin.dashboard },
    { label: "users", active: true },
  ];

  const [filters, setFilters] = useState<{
    [key: string]: string | number | null;
  }>({});

  useEffect(() => {
    handleGetUsers({
      page: 1,
      limit: 10,
    });
  }, [handleGetUsers]);

  const filterFields: FilterField[] = [
    {
      key: "search",
      label: t("search"),
      type: "text",
    },
    {
      key: "role",
      label: t("role"),
      type: "select",
      options: ROLE_OPTIONS(t),
    },
    {
      key: "status",
      label: t("status"),
      type: "select",
      options: [
        { label: t("active"), value: "active" },
        { label: t("inactive"), value: "inactive" },
        { label: t("deleted"), value: "deleted" },
      ],
    },
  ];

  const handleFilter = (newFilters: {
    [key: string]: string | number | null;
  }) => {
    setFilters(newFilters);
    handleGetUsers({
      ...newFilters,
      page: 1,
      limit: 10,
    });
  };

  const handleRestore = async (record: User, status: "active" | "deleted") => {
    const ok = await handleUpdate(record.id, { status } as any);
    if (ok) {
      handleGetUsers({
        ...filters,
        page: infoPagination.page || 1,
        limit: infoPagination.limit || 10,
      });
    }
  };

  const onResetFilter = () => {
    setFilters({});
    handleGetUsers({
      page: 1,
      limit: 10,
    });
  }

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <PageHeader title={t("users")} breadcrumbItems={breadcrumbItems} />

        <div className="d-flex mb-3 justify-content-end gap-2">
          <TableFilterDynamique
            fields={filterFields}
            filters={filters}
            onApply={handleFilter}
            onReset={onResetFilter}
          />
        </div>

        <UsersTable
          dataSource={users}
          loading={loading}
          pagination={true}
          dataPaginate={{
            current: infoPagination?.page,
            pageSize: infoPagination?.limit,
            total: infoPagination?.total,
          }}
          onChange={(pg: any) => {
            const newPagination = {
              page: pg.current || 1,
              limit: pg.pageSize || 10,
            };

            handleGetUsers({
              ...filters,
              page: newPagination.page,
              limit: newPagination.limit,
            });
          }}
          onUpdateStatus={handleRestore}
        />
      </div>
    </div>
  );
};

export default UsersPage;
